import _ from "lodash";
import {
  Component,
} from "react";
import store from "CommonState/store";
import {
  DetailValue,
  generateControl,
  prepareChoices,
  requiredClass,
} from "CommonComponents/detail-view";
import {
  injectFunction,
  injectGenerator,
} from "CommonCore/schema-util";
import {
  Button,
  Col,
  Container,
  FormText,
  Row,
} from "react-bootstrap";
import {
  EditPanel,
  formatValue,
  Panel,
  Radio,
} from "CommonComponents/bricks";
import {
  formatDate,
} from "CommonCore/l10n";
import ContextHelpButton from "Components/context-help";
import apifetch from "CommonCore/apifetch";
import {
  updateStats,
} from "Components/db-widget-angaben";

// Custom-Controls, die speziell für die SHK-Forms erstellt wurden
export const customControls = {
  radioheader: function({ schema, message, entity, injects, onChange, key, errorLookup }) {
    const choices = prepareChoices(schema, entity, injects);
    const value = entity[schema.field];

    const content = <Container fluid>
      <Row>
        <Col xs={10}><b><h5>{schema.display}</h5></b></Col>
        <Col xs={2}>{choices.map(item => <Radio
          key={item.value}
          label={item.label}
          name={"radio" + schema.field}
          disabled={item.disabled}
          checked={(value === item.value) || false}
          onChange={() => onChange(schema, item.value)} />)}
        {message && <FormText>{message}</FormText>}
        </Col>
      </Row>
    </Container>;
    const bodyContent = content;
    const headerContent = "";
    const detailContent = getDetailContent({ entity, schema, onChange, injects, errorLookup });

    return <div key={key} className='box-panel'><Panel header={headerContent}>{bodyContent} {detailContent}</Panel></div>;
  },
  radioheader_view: function({ schema, entity, injects, onChange, key, errorLookup }) {
    const choices = prepareChoices(schema, entity, injects);
    const value = entity[schema.field];
    const getLabel = value => {
      try {
        return choices.find(item => item.value == value).label;
      } catch(err) {
        return "";
      }
    };
    const content = <Container fluid>
      <Row>
        <Col xs={10}><b><h5>{schema.display}</h5></b></Col>
        <Col xs={2}>{getLabel(value)}</Col>
      </Row>
    </Container>;
    const bodyContent = content;
    const headerContent = "";

    const detailContent = getDetailContent({ entity, schema, onChange, injects, errorLookup, viewmode: true });
    if (detailContent) {
      return <div key={key || schema.field} className='box-panel'><Panel header={headerContent}>{bodyContent} {detailContent}</Panel></div>;
    }
    return <Panel key={key || schema.field} header={headerContent}>OHNE{bodyContent}</Panel>;
  },

  radioheader2: function({ schema, message, entity, injects, onChange, key, errorLookup }) {
    // Optionen unter dem Header (bei langen Optionstexten)
    const choices = prepareChoices(schema, entity, injects);
    const value = entity[schema.field];
    const content = <Container fluid>
      <Row><Col lg={12}><h5 style={{ fontWeight: "bold" }}>{schema.display}</h5></Col></Row>
      <Row>
        <Col lg={12} {...requiredClass(schema)}>{choices.map((item, i) => <Radio
          key={item.value}
          label={item.label}
          name={"radio" + schema.field + "-" + i}
          disabled={item.disabled}
          checked={(value === item.value) || false}
          onChange={() => onChange(schema, item.value)} />)}
        {message && <FormText>{message}</FormText>}
        </Col>
      </Row>
    </Container>;
    const bodyContent = content;
    const detailContent = getDetailContent({ entity, schema, onChange, injects, errorLookup });
    return <div key={key || schema.field} className='box-panel'><Panel>{bodyContent}{detailContent} </Panel></div>;
  },
  radioheader2_view: function({ schema, entity, injects, onChange, id, errorLookup }) {
    const choices = prepareChoices(schema, entity, injects);
    const value = entity[schema.field];
    const getLabel = value => {
      try {
        return (value === undefined || value === null || value.length == 0) ? <b>- Angabe fehlt -</b> : choices.find(item => item.value == value).label;
      } catch(err) {
        return "";
      }
    };
    const content = <Container fluid>
      <Row><Col lg={12}><h5 style={{ fontWeight: "bold" }}>{schema.display}</h5></Col></Row>
      <Row><Col lg={12}>{getLabel(value)}</Col></Row>
    </Container>;
    const bodyContent = content;

    const detailContent = getDetailContent({ entity, schema, onChange, injects, errorLookup, viewmode: true });

    if (detailContent) {
      return <div key={id || schema.field} className='box-panel'><Panel>{bodyContent}{detailContent}</Panel></div>;
    }
    return <Panel key={id || schema.field}>{bodyContent}</Panel>;
  },


  plaintext: function({ schema, entity, injects, onChange, key, errorLookup }) {
    const detailContent = getDetailContent({ entity, schema, onChange, injects, errorLookup });
    const getHTML = () => {
      return { __html: schema.display };
    };
    return <Panel key={key || schema.field}><Container fluid>
      <Row> <Col xs={12}><div dangerouslySetInnerHTML={getHTML()} /> </Col> </Row>
    </Container>{detailContent}</Panel>;
  },
  plaintext_view: function({ schema, message, entity, injects, onChange, id }) {
    const detailContent = getDetailContent({ entity, schema, onChange, injects, message, viewmode: true });
    const getHTML = () => {
      return { __html: schema.display };
    };
    return <Panel key={id || schema.field}><Container fluid>
      <Row> <Col xs={12}><div dangerouslySetInnerHTML={getHTML()} /> </Col> </Row>
    </Container>{detailContent}</Panel>;
  },
};

function getDetailContent({ entity, schema, onChange, injects, errorLookup, viewmode }) {
  // Subitems für Editor in Container darstellen
  let fields = _.cloneDeep(schema.subitems);
  const toHide = [];
  if (fields) {
    if (schema.dependends) {
      // Abhängige Felder definiert
      _.map(schema.dependends, group => {
        if (group.invisibleIf(entity[schema.field], entity, injects)) {
          // Alle Felder der aktuellen Gruppe merken, die unsichtbar werden sollen
          toHide.push(...group.fields);
        }
      });
    }
    if (toHide.length) {
      // Zu verbergende Felder entfernen
      fields = _.filter(fields, item => toHide.indexOf(item.field) < 0);
    }
  }
  return fields && fields.length > 0 && <div className='detail-table container-fluid'><br />
    {!viewmode && _.map(fields, (item, index) => {
      if (!item.hideFromEditor || !injectFunction(item.hideFromEditor, injects)(entity)) {
        return generateControl({ schema: item, entity, injects, onChange, errorLookup, key: item.field || index }, customControls);
      }
      return null;
    })}
    {viewmode && _.map(fields, (item, index) => {
      if (!item.hideFromEditor || !injectFunction(item.hideFromEditor, injects)(entity, { readonly: true })) {
        return <DetailValue key={item.field || index} customControls={customControls} entity={entity} injects={injects} schema={item} />;
      }
      return null;
    })}

  </div>;
}

const typeRenderMethods = {
  plaintext: field_schema => () => {
    return field_schema.display;
  },
};

@store("flag_antragstellermodus")
export default class SHKFormTab extends Component {
  constructor() {
    super();
    this.state = {
      edits: {},
      entity: {},
      panelsettings: {},
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.needReload && !prevProps.needReload) {
      this.fetchData();
    }
  }

  fetchData() {
    const { preparedData } = this.props;

    // alle verwendeten Endpoints ermitteln
    const endpoints = _.uniq(_.map(this.subpanels, panel => panel.endpoint));

    function fetchall(endpoints) {
      const promiseArray = _.map(endpoints, endpoint => apifetch(endpoint));

      return Promise.all(promiseArray);
    }
    const state = _.cloneDeep(this.state);

    if (preparedData == {} || !preparedData) {
      // Endpoints lesen
      fetchall(endpoints).then(data => {
        // Daten verteilen und mappen wenn nötig
        for (let i = 0; i < data.length; i++) {
          _.map(_.filter(this.subpanels, panel => panel.endpoint == endpoints[i]), panel => {
            if (panel.transformData) {
              // Panel die Daten anpassen lassen (das ganze Array (ggf. inkl. Historie) wird übergeben)
              panel.transformData(panel.property ? data[i].data[0][panel.property] : data[i].data[0]);
            }
          });

          const entity = data[i].data[0];
          _.map(_.filter(this.subpanels, panel => panel.endpoint == endpoints[i]), panel => {
            // Mapping auf Property beachten
            const paneldata = !panel.property ? entity : !_.isEmpty(entity[panel.property]) ? entity[panel.property][0] : null;

            const convSyncvalue = item => {
              // syncValue präfix mit field abgleichen, damit es auch in Anträgen funktioniert
              const prefField = item.field.split("_")[0];
              const prefSyncvalue = item.syncValue.split("_")[0];
              return item.syncValue.replace(prefSyncvalue, prefField);
            };

            // syncValue auswerten: Feldwerte aus Service in künstliche Spalten kopieren
            const syncValues = (table, data) => {
              _.map(table, item => {
                if (item.syncValue) {
                  data[item.field] = _.clone(data[convSyncvalue(item)]); // Wert aus realem Feld übertragen
                }
                if (item.subitems) {
                  syncValues(item.subitems, data);
                }
              });
            };
            if (paneldata) {
              syncValues(panel.schema.table, paneldata);
            }
            state[panel.key] = paneldata;
          });
        }

        this.setState(state, () => {
          _.map(this.subpanels, panel => this.checkTrigger(panel.key));
          this.props.onUpdate && this.props.onUpdate(this.state);
        });
        return;
      }).catch(function() {
        const e = Error();
        e.response = { nachricht: "Fehler beim Laden der Daten" };
        throw e;
      });
    } else {
      // Daten wurden übergeben
      _.map(this.subpanels, panel => {
        state[panel.key] = preparedData;
      });

      // Trigger auslösen
      this.setState(state, () => {
        _.map(this.subpanels, panel => this.checkTrigger(panel.key));
        this.props.onUpdate && this.props.onUpdate(this.state);
      });
    }
  }

  componentDidMount() {
    this.subpanels = this.props.subpanels;
    const { args } = this.props;

    // Curry-Wrapper
    const changeHandler = panel => (changes => this.update(changes, panel));
    const saveHandler = panel => (() => this.onSave(panel));
    const schemaEntity = panel => (() => this.getEntity(panel));
    const deleteHandler = panel => (entity => this.onDelete(panel, entity));

    const beginEditHandler = panel => (edits => this.onBeginEdit(edits, panel));
    const toggleHistory = panel => (() => this.onToggleHistory(panel));
    const toggleHelp = panel => (content => this.onToggleHelp(content, panel));

    // Injects (benötigte Lookps) und Functions je Subpanel vorbereiten
    _.map(this.subpanels, item => {
      item.onChange = changeHandler(item);
      item.onSave = saveHandler(item);
      item.onDelete = deleteHandler(item);
      item.getEntity = schemaEntity(item);
      item.onBeginEdit = beginEditHandler(item);
      item.toggleHistory = toggleHistory(item);
      item.toggleHelp = toggleHelp(item);

      // Endpunkt-Argumente anwenden (Variable ersetzen)
      if (args) {
        _.map(Object.keys(args), key => {
          if (!item.endpointpattern) {
            item.endpointpattern = item.endpoint;
          }
          item.endpoint = item.endpointpattern.replace(`<${ key }>`, args[key]);
        });
      }
    });
    this.fetchData();
  }

  getEntity(panel) {
    // Entity des Panels aus Original plus Edits zusammensetzen und liefern
    const data = this.state[panel.key];
    const entityWithEdits = _.assign({}, data, this.state.edits[panel.key]);
    const updated = entityWithEdits;// _.assign(defaultFromSchema(panel.schema, null, entityWithEdits), entityWithEdits)
    return updated;
  }


  getInvisibleDependends = (table, entity) => {
    // Liste unsichtbarer abhängiger rekursiv ermitteln
    const visibleListe = [];
    const invisibleListe = [];
    _.map(table, item => {
      if (item.dependends) {
        _.map(item.dependends, group => {
          const bool = group.invisibleIf(entity[item.field], entity, this.props.injects);
          if (bool) {
            invisibleListe.push(...group.fields);
          } else {
            visibleListe.push(...group.fields);
          }
        });
      }
      if (item.subitems) {
        invisibleListe.push(...this.getInvisibleDependends(item.subitems, entity));
      }
    });
    // subtract fields that are visible AND invisible (different dependency paths)
    return invisibleListe.filter(field => !visibleListe.find(visibleField => visibleField === field));
  };

  checkTrigger(panel) {
    // Von Schema/Table gesteuerte Logik zum löschen von nicht mehr benötigten Edits
    const entity = panel.getEntity && panel.getEntity();
    if (!entity) {
      return false;
    }
    const toClear = this.getInvisibleDependends(panel.schema.table, entity);

    if (toClear.length) {
      const edits = this.state.edits;
      _.map(toClear, field => {
        edits[panel.key][field] = null;
      });
      this.setState({ edits });
    }

    // Hier darf das Panel bei Bedarf die Edits verändern
    if (panel.checkTrigger) {
      const result = panel.checkTrigger(panel.getEntity(), this.state.edits[panel.key]);
      if (result.edits) {
        const edits = this.state.edits;
        edits[panel.key] = result.edits;
        this.setState({ edits });
      }
    }
  }

  render() {
    const { panelsettings } = this.state;

    // this.props.onRender && this.props.onRender({reloadForm: this.componentDidMount })

    const filterSchema = panel => {
      // Anpassungen am Schema je nach Datenlage
      const entity = panel.getEntity();
      const toHide = [];
      const filteredSchema = _.cloneDeep(panel.schema);
      if (!panel.renderMethods) {
        panel.renderMethods = {};
      }
      _.map(filteredSchema.table, item => {
        if (item.type == "plaintext") {
          panel.renderMethods[item.field] = typeRenderMethods.plaintext(item); // Schemainfo in Function curry'en
        }
        if (item.dependends) {
          _.map(item.dependends, group => {
            const bool = group.invisibleIf(entity[item.field], entity, this.props.injects);
            if (bool) {
              toHide.push(...group.fields);
            }
          });
        }
      });
      if (toHide.length) {
        filteredSchema.table = _.filter(filteredSchema.table, item => toHide.indexOf(item.field) < 0);
        return filteredSchema;
      }

      if (panel.filterSchema) {
        // Im Panel selbst definierte Filterfunktion
        return panel.filterSchema(panel.getEntity());
      }
      return panel.schema;
    };

    return <div className='detail-form'>{_.map(this.subpanels, panel => {
      if (panel.invisibleIf && panel.invisibleIf(this.state)) {
        // Panel möchte nicht angezeigt werden
        return null;
      }

      // Prüfen, ob das aktuelle Panel laut URL als Anker focussiert werden soll
      const location = window.location;
      if (location.hash !== this.lastAnchor && location.hash === "#" + panel.key) {
        this.lastAnchor = location.hash;
        setTimeout(() => {
          const target = document.getElementById(panel.key);
          if (target) {
            target.scrollIntoView();
          }
        }, 50);
      }

      const entity = panel.getEntity();
      const hasHistory = entity.hasOwnProperty("history") &&
        filterSchema(panel).table.find(f => entity.history[0].hasOwnProperty(f.field));

      const mydata = panelsettings[panel.key] || {};

      const getHistoryHeader = () => {
        if (hasHistory) {
          return <Panel variant='warning'>
            Bei diesen Angaben gibt es Änderungen zum letzten Stand vom {formatDate(entity.history[0]._histdate)} {"\u00a0"}<Button variant='outline-primary' onClick={panel.toggleHistory}>{`Letzten Stand ${ !mydata.showHistory ? "einblenden" : "ausblenden" }`}</Button>
          </Panel>;
        }
        return null;
      };

      return <span key={panel.key}><a id={panel.key} />
        { !panel.component ?
        <EditPanel
          key={panel.key}
          editOnClick={!this.props.readonly}
          defaultEditable={this.props.editPanel && this.props.editPanel.key == panel.key}
          entity={_.isEmpty(mydata) || !mydata.showHistory ? _.omit(entity, "history") : entity}
          editable={!this.props.readonly && !(this.state.inEditPanel && this.state.inEditPanel.key != panel.key)}
          header={<span key={panel.key}><h4 key='h4'>{panel.header}<ContextHelpButton onClick={panel.toggleHelp} custompath={`${ window.location.pathname }#${ panel.key }`} /></h4>
            {getHistoryHeader()}</span>}
          collapsible
          schema={filterSchema(panel)}
          onChange={panel.onChange}
          onClose={this.onClose}
          onSave={panel.onSave}
          onBeginEdit={panel.onBeginEdit}
          customControls={customControls}
          renderMethods={panel.renderMethods}
          injects={this.props.injects}
          noToggleOnSave={this.props.noToggleOnSave}>
          {mydata.showHelp && <div style={{ padding: "8px", border: "1px solid", borderRadius: "4px", backgroundColor: "#fcf8e3", borderColor: "#faebcc" }}>{formatValue(mydata.helpContent, { type: "markdown", field: "text" })}</div>}
        </EditPanel>
        : <panel.component
          noWorkflowWrapper
          subpanels={[panel]}
          action={panel.action}
          items={entity[panel.propertyName]}
          typUniqueField={panel.uniqueField}
          editable={!(this.props.readonly || panel.readonly) && !(this.state.inEditPanel && this.state.inEditPanel.key != panel.key)}
          onSave={panel.onSave}
          onDelete={panel.onDelete}
          onClose={this.onClose}
          customControls={customControls}
          onBeginEdit={panel.onBeginEdit}
          schema={panel.schema}
          beforeFieldsContent={panel.getBeforeFieldsContent}
          afterFieldsContent={panel.getAfterFieldsContent}
          panelNameNew='Postion hinzufügen'
          panelName={_.isFunction(panel.header) ? panel.header(entity) : panel.header}
          onValidate={panel.onValidate}
          injects={this.props.injects} />}

      </span>;
    })}</div>;
  }

  onBeginEdit(edits, panel) {
    // Hier können wir die initialen Werte einer Entität verändern, wenn das EditPanel in den EditMode wechselt
    const defaults = {};
    _.map(panel.schema.table, fld => {
      if (fld.hasOwnProperty("initValue")) {
        if (!panel.getEntity()[fld.field]) {
          if (!_.isFunction(fld.initValue)) {
            defaults[fld.field] = fld.initValue;
          } else {
            const gen = injectGenerator(fld.initValue, fld.inject, this.props.injects);
            defaults[fld.field] = gen();
          }
        }
      }
    });
    if (!_.isEmpty(defaults)) {
      edits = defaults;
    }

    this.update(edits, panel); // Defaultwerte in Edits übertragen
    this.setState({ inEditPanel: panel });
  }

  update = (changes, panel) => {
    // Änderungen aus dem Detaileditor annehmen und merken
    const allEdits = this.state.edits;
    if (!allEdits[panel.key]) {
      allEdits[panel.key] = {};
    }
    const edits = _.assign({}, allEdits[panel.key], changes);

    // Im Schema definierte Reaktion auf Änderungen aufrufen
    const { validateEdits } = panel;
    validateEdits && validateEdits(this.state[panel.key], edits, allEdits[panel.key]);
    allEdits[panel.key] = edits;

    this.setState({ edits: allEdits }, () => {
      // Trigger auf Feldwerte
      this.checkTrigger(panel);
    });
  };

  onClose = () => {
    // Cleanup
    this.setState({ edits: {}, inEditPanel: null });
    this.props.onClose && this.props.onClose(this.props.dataId);
  };

  onToggleHistory = panel => {
    const { panelsettings } = this.state;
    panelsettings[panel.key] = panelsettings[panel.key] || {};
    const hist = panelsettings[panel.key].showHistory;
    panelsettings[panel.key].showHistory = !hist;
    this.setState({ panelsettings });
  };

  onToggleHelp = (content, panel) => {
    const { panelsettings } = this.state;
    panelsettings[panel.key] = panelsettings[panel.key] || {};
    panelsettings[panel.key].helpContent = { text: content };
    panelsettings[panel.key].showHelp = !panelsettings[panel.key].showHelp;
    this.setState({ panelsettings });
  };

  onDelete = async(panel, Id) => {
    if (_.isFunction(panel.onCustomDelete)) {
      // Panel hat eigene Speicherfunktion
      await panel.onCustomDelete(panel, Id, this.props);
      this.fetchData();
      return true;
    }
  };

  onSave = panel => {
    const edits = this.state.edits[panel.key];
    this.setState({ validationMessage: null });

    /*
     *if (_.isFunction(panel.onCustomSave)) {
     * // Panel hat eigene Speicherfunktion
     *await panel.onCustomSave(panel, newEntity, this.props)
     *this.setState({ edits: {}, inEditPanel: null });
     *this.fetchData()
     *return true
     *}
     */

    const details = [];
    const entity = panel.getEntity();

    // Panels beforeSave Methode verwenden, falls gesetzt
    if (panel.beforeSave) {
      panel.beforeSave(entity, edits);
    }

    // syncValue auswerten: Feldwerte aus künstlichen Spalten in Edits kopieren
    const syncValues = (table, edits) => {
      _.map(table, item => {
        if (item.syncValue) {
          if (edits[item.field]) {
            edits[item.syncValue] = _.clone(edits[item.field]); // Wert in reales Feld übertragen
          }
        }
        if (item.subitems) {
          syncValues(item.subitems, edits);
        }
      });
    };
    syncValues(panel.schema.table, edits);

    // Bearbeitungen modifizieren?
    if (panel.schema.checkEdits) {
      panel.schema.checkEdits(edits, entity);
    }

    // Validierungen aufrufen
    /*
     * Abhaengige Felder, die im Editor nicht angezeigt werden, duerfen auch nicht
     * als Pflichtfelder validiert werden (z. B. Behindertengrad bei "Nein").
     */
    const invisibleDependends = new Set(this.getInvisibleDependends(panel.schema.table, entity));
    const validateList = (array, entity, list, modus) => {
      _.map(list, schema => {
        const isHidden = invisibleDependends.has(schema.field)
          || (schema.hideFromEditor && injectFunction(schema.hideFromEditor, this.props.injects)(entity));
        if (!isHidden) {
          const isRequired = _.isFunction(schema.required) ? schema.required(entity) : schema.required;
          const value = entity[schema.field];
          if (isRequired && (value == null || value === "")) {
            details.push({ attribut: schema.field, nachricht: `${schema.display} ist ein Pflichtfeld` });
          } else if (schema.validate) {
            const message = schema.validate(value, entity, modus);
            if (message) {
              details.push({ attribut: schema.field, nachricht: message });
            }
          }
        }
        if (schema.subitems) {
          validateList(array, entity, schema.subitems, modus);
        }
      });
    };
    validateList(details, entity, panel.schema.table, this.props.flag_antragstellermodus);

    if (!_.isEmpty(details)) {
      const e = Error();
      e.response = { nachricht: "Es sind Fehler bei der Validierung aufgetreten", details: details };
      throw e;
    }


    edits && _.map(Object.keys(edits), key => {
      // Leerstrings zu Null umwandeln
      if (_.trim(edits[key]) == "") {
        edits[key] = null;
      }
    });


    if (!_.isEmpty(edits)) {
      if (this.props.onSave) {
        // externe Speicherfunktion verwenden
        this.props.onSave(this.getEntity(panel));
        updateStats(this.props); // Angabenstatus aktualisieren
      } else {
        // Interne Speicherfunktion für private 1:1 Tabellen
        const save = async() => {
          await apifetch(panel.endpoint, {
            method: "POST",
            body: edits,
          });
          updateStats(this.props); // Angabenstatus aktualisieren
        };
        save();
      }
    }
    const updated = this.getEntity(panel);
    const stateUpdates = { [panel.key]: updated };

    /*
     * Geschwister-Panels, die denselben Endpoint (dieselbe Entität) nutzen, ebenfalls aktualisieren,
     * damit z.B. eine in "Kontaktdaten" gespeicherte Änderung sofort auch in "Bankverbindung"
     * sichtbar wird (statt erst nach einem Reload)
     */
    _.map(this.subpanels, sibling => {
      if (sibling.key !== panel.key && sibling.endpoint === panel.endpoint && !sibling.property && !panel.property) {
        stateUpdates[sibling.key] = _.assign({}, this.state[sibling.key], edits);
      }
    });
    this.setState(stateUpdates);

    // Aktuelle Daten melden
    this.props.onUpdate && this.props.onUpdate(this.state);

    this.onClose();
  };
}

export function setupLookups(schema) {
  // Zusammenhängende Properties zu Lookupdefinitionen setzen

  let allFields = [];
  if (!schema) {
    return null;
  }
  if (schema.table) {
    // Toplevel aufgerufen
    allFields = schema.table;
  } else {
    // mit Feldschema.items (Array) aufgerufen
    allFields = schema;
  }

  const toRemoveFromMain = []; // Felder, die unter die (Layout-)Kontrolle eines anderen gestellt werden

  _.map(allFields, item => {
    if (item.dependends) {
      /*
       * Item hat abhängige Elemente (nicht unbedingt grafisch gesehen Children/Untergeordnete)
       * Name des die Abhängigkeit auslösenden Feldes merken:
       */
      item.subitems = [];
      _.map(item.dependends, set => {
        _.map(set.fields, name => {
          try {
            // Info: Parent muss im gleichen Sub-Baum liegen
            const fld = allFields.find(x => x.field == name);
            fld.dependendOn = item.field;
            if (!set.noContainer) {
              /*
               * noContainer=true -> abhängige Felder bleiben auf gleicher Ebene, sonst (default) werden sie als Subitems interpretiert und
               * in der Anzeige in einer Box unterhalb des Parents dargestellt
               */
              item.subitems.push(fld);
              toRemoveFromMain.push(fld.field);
            }
          } catch(err) {
            console.log(`setDependendOn: Dependend ${ name } unbekannt`);
          }
        });
      });
    }
    if (item.type == "array") {
      // Array-Items betrachten
      item.items && setupLookups(item.items);
    } else {
      // Kein Array
      const buildLookupProps = ({ item, type, lookuptable, idname, labelname }) => {
        // Choices, Selector und Inject für Standard-Lookups befüllen
        _.assign(item, {
          type: type,
          choices: lookup => {
            try {
              const values = lookup && Object.values(lookup);
              if (values && values.length > 0) {
                const prefix = Object.keys(values[0])[0].split("_")[0];
                return _.map(lookup, l => ({ value: l[idname || prefix + "_id"], label: l[labelname || prefix + "_kbez"] }));
              }
            } catch(err) {
              console.log("choices: " + err.message);
            }
            return [];
          },
          inject: [lookuptable + "Lookup"],
          selector: lookup => id => {
            const values = lookup && id && Object.values(lookup);
            if (values && values.length > 0) {
              const prefix = Object.keys(values[0])[0].split("_")[0];
              return _.get(lookup, [id, labelname || prefix + "_bez"], "");
            }
          },
        });

        // Filter-Properties (aktuell nur wenn idname und labelname bekannt sind)
        if (labelname && idname) {
          _.assign(item, {
            filter: {
              filterbox: {
                inject: lookuptable,
                choices: list => {
                  try {
                    if (list && list.length > 0) {
                      const prefix = Object.keys(list[0])[0].split("_")[0];
                      return _.sortBy(list.map(v => v[labelname || prefix + "_kbez"]));
                    }
                  } catch(err) {
                    console.log("choices: " + err.message);
                  }
                  return [];
                },
              },
              subquery: {
                inject: [`${ lookuptable }Lookup`],
                fields: { [item.field]: { alias: labelname } },
                generator: lookup => entity => lookup && lookup[entity[item.field]],
              },
            },
          });
        }
      };

      if (item.lookup) {
        // Lookup-Shorthand in Framework-Properties auflösen
        if (_.isObject(item.lookup)) {
          // Objektnotation verwendet
          const { editType, values, settings } = item.lookup;
          if (settings) {
            // übergebene Settings (choices, selector, filter etc.) übernehmen
            _.assign(item, settings);
          } else {
            // Einstellungen für feste Werteliste (values ist ein Array)
            _.assign(item, {
              type: editType,
              choices: values,
              selector: value => value == null ? "" : values.find(x => x.value == value).label,
              // TODO: filter
            });
          }
        } else {
          // Stringnotation annehmen
          const args = item.lookup.split(".");
          switch (args[0]) {
            case "boolean":
              switch (args[1]) {
                case "radio":
                case "radioheader":
                case "radioheader2":
                  _.assign(item, {
                    type: args[1],
                    choices: [{ value: true, label: "Ja" },
                              { value: false, label: "Nein" }],
                    selector: value => value == null ? "" : value ? "Ja" : "Nein",
                  });
                  break;
                default:
                  _.assign(item, { type: "checkbox" });
                  break;
              }
              break;
            default:
              // Lookup-Tabelle annehmen ('<tabelle>.[select,radio,radioheader,radioheader2][.<idname>][.labelname]')
              buildLookupProps({ item: item, type: args[1], lookuptable: args[0], idname: args[2], labelname: args[3] });
              break;
          }
        }
      }
    }
  });
  if (toRemoveFromMain) {
    // Angepasste Liste abzüglich der zu einem Parent als Subitems verschobenen Felder liefern
    return allFields.filter(fld => toRemoveFromMain.indexOf(fld.field) < 0);
  }
    // Angepasste Liste liefern
  return allFields;
}

export function buildSubSchema(schema, subtag) {
  // Schema clonen und Table nach Subtag filtern
  const sub = _.cloneDeep(schema);
  sub.table = schema.table.filter(x => x.subtag == subtag);
  return sub;
}
export function buildSubSchemas(panels, schema) {
  // Subschemas für die übergebenen Panels erzeugen
  return _.map(panels, panel => panel.schema = buildSubSchema(schema, panel.key));
}

// Prefixe und Endpunkt patchen
export function patchPrefix(list, from, to) {
  const patch = field => {
    if (field.startsWith(from)) {
      return to + field.substring(from.length);
    } return field;
  };
  _.map(list, item => {
    // Prefix ersetzen (Zur Sicherheit kein replace)
    item.field = patch(item.field);
    if (item.dependends) {
      _.map(item.dependends, group => group.fields = _.map(group.fields, field => patch(field)));
    }
    if (item.subitems) {
      // Rekursiv für Subitems aufrufen
      patchPrefix(item.subitems, from, to);
    }
  });
}

export function setupAntragPanels(panels, mapping) {
  // Personen-Panel-Metadaten konvertieren
  _.map(panels, panel => {
    // Passendes Mapping finden
    const map = mapping.find(m => m.endpoint == panel.endpoint);
    panel.endpoint = "/api/shkantrag/antrag/<a_id>";
    panel.property = map.prop;
    patchPrefix(panel.schema.table, map.pfrom, map.pto);

    // Prefixe in renderMethods patchen
    if (map && panel.renderMethods) {
      _.map(Object.keys(panel.renderMethods), key => {
        if (key.startsWith(map.pfrom)) {
          panel.renderMethods[key.replace(map.pfrom, map.pto)] = panel.renderMethods[key];
          delete panel.renderMethods[key];
        }
      });
    }
  });
}

export function emptyOrFalse(value) {
  return value == null || !value;
}
export function emptyOrTrue(value) {
  return value == null || value;
}
export function empty(value) {
  return value == null;
}
